(function(){
'use strict';
if(window.__elzForms)return;window.__elzForms=true;
function toast(m,o){if(window.elzToast)window.elzToast(m,o||{})}

/* WhatsApp numbers: accept +92..., 0092..., 03xx... and always give wa.me the international format */
function waNum(raw){
  var d=String(raw||'').replace(/\D/g,'');
  if(d.indexOf('00')===0)d=d.slice(2);
  if(d.length===11&&d.charAt(0)==='0')d='92'+d.slice(1);
  else if(d.length===10&&d.charAt(0)==='3')d='92'+d;
  return d;
}
function fixLinks(){
  Array.prototype.forEach.call(document.querySelectorAll('a[href*="wa.me/"]'),function(a){
    var m=a.getAttribute('href').match(/wa\.me\/([^?#]*)(.*)$/);
    if(!m)return;
    var n=waNum(decodeURIComponent(m[1]));
    if(n)a.setAttribute('href','https://wa.me/'+n+(m[2]||''));
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fixLinks);else fixLinks();
document.addEventListener('shopify:section:load',fixLinks);

/* tracking page: message on WhatsApp (runs before the older handler and replaces it) */
document.addEventListener('click',function(e){
  var b=e.target.closest&&e.target.closest('[data-trk-wa]');if(!b)return;
  e.stopPropagation();e.preventDefault();
  var card=b.closest('.elz-trk__card'),ord=card.querySelector('[data-trk-order]'),msg=card.querySelector('textarea');
  var o=(ord.value||'').replace(/[^0-9A-Za-z#-]/g,'');
  if(!o){toast('Please enter your order number first.',{type:'error',title:'Order number needed'});ord.focus();return}
  var n=waNum(b.dataset.num);
  if(!n){toast('Our WhatsApp number is not set up yet. Please use the email form.',{type:'error',title:'WhatsApp unavailable'});return}
  var extra=(msg.value||'').trim();
  var text='Hi '+(b.dataset.brand||'')+', I need an update on my order '+(o.charAt(0)==='#'?o:'#'+o)+'.'+(extra?'\n\n'+extra:'');
  window.open('https://wa.me/'+n+'?text='+encodeURIComponent(text),'_blank','noopener');
  toast('WhatsApp is opening. Tap Send there to deliver your message.',{type:'info',title:'Almost done'});
},true);

/* contact + tracking email forms: loading -> success, errors only when the message really failed */
document.addEventListener('submit',function(e){
  var f=e.target;
  if(!f||(f.id!=='ElzTrackForm'&&f.id!=='ElzContactForm'))return;
  e.stopPropagation();e.preventDefault();
  if(f.dataset.sending==='1')return;
  f.dataset.sending='1';
  var btn=f.querySelector('button[type=submit]');if(btn)btn.classList.add('is-loading');
  function done(){f.dataset.sending='0';if(btn)btn.classList.remove('is-loading')}
  function ok(){
    var m=f.querySelector('.elz-ok,.elz-err');if(m)m.remove();
    f.reset();
    toast(f.id==='ElzContactForm'?'Thank you. We have received your message and will reply soon.':'Your message was sent. We will reply soon.',{title:'Message sent'});
  }
  fetch(f.action,{method:'POST',body:new FormData(f),credentials:'same-origin'}).then(function(res){
    var u=res.url||'';
    if(u.indexOf('/challenge')>-1){done();f.submit();return}
    if(res.redirected||u.indexOf('contact_posted')>-1){ok();done();return}
    return res.text().then(function(html){
      var d=new DOMParser().parseFromString(html,'text/html');
      if(d.querySelector('#'+f.id+' .elz-ok')){ok();return}
      var er=d.querySelector('#'+f.id+' .elz-err');
      toast((er&&er.textContent.trim())||'Please check your details and try again.',{type:'error',title:'Message not sent'});
    }).then(done);
  }).catch(function(){done();f.submit()});
},true);
})();
